<template>
    <div class="loading-mask-layer" v-show="MASK_ACTIVE" @mousewheel.stop.prevent>
        <div class="lds-default">
            <div v-for="index in 12" class="lds-dot" :key="`lds-dot-${index}`"></div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: "loadingMask",

    components: {},
    data: () => ({}),
    created() {},
    mounted() {},
    watch: {},
    computed: {
        ...mapState({
            MASK_ACTIVE: state => state.LoadingMask.MASK_ACTIVE,
        })
    },
    methods: {}
};
</script>

<style lang="scss" scoped>
.loading-mask-layer {
    position: fixed;
    z-index: 999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    top: 0;
    left: 0;

    .lds-default {
        display: inline-block;
        position: absolute;
        width: 80px;
        height: 80px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .lds-default div {
        position: absolute;
        width: 6px;
        height: 6px;
        background: #fff;
        border-radius: 50%;
        animation: lds-default 1.2s linear infinite;
    }
    .lds-default div:nth-child(1) {
        animation-delay: 0s;
        top: 37px;
        left: 66px;
    }
    .lds-default div:nth-child(2) {
        animation-delay: -0.1s;
        top: 22px;
        left: 62px;
    }
    .lds-default div:nth-child(3) {
        animation-delay: -0.2s;
        top: 11px;
        left: 52px;
    }
    .lds-default div:nth-child(4) {
        animation-delay: -0.3s;
        top: 7px;
        left: 37px;
    }
    .lds-default div:nth-child(5) {
        animation-delay: -0.4s;
        top: 11px;
        left: 22px;
    }
    .lds-default div:nth-child(6) {
        animation-delay: -0.5s;
        top: 22px;
        left: 11px;
    }
    .lds-default div:nth-child(7) {
        animation-delay: -0.6s;
        top: 37px;
        left: 7px;
    }
    .lds-default div:nth-child(8) {
        animation-delay: -0.7s;
        top: 52px;
        left: 11px;
    }
    .lds-default div:nth-child(9) {
        animation-delay: -0.8s;
        top: 62px;
        left: 22px;
    }
    .lds-default div:nth-child(10) {
        animation-delay: -0.9s;
        top: 66px;
        left: 37px;
    }
    .lds-default div:nth-child(11) {
        animation-delay: -1s;
        top: 62px;
        left: 52px;
    }
    .lds-default div:nth-child(12) {
        animation-delay: -1.1s;
        top: 52px;
        left: 62px;
    }
    @keyframes lds-default {
        0%,
        20%,
        80%,
        100% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.5);
        }
    }
}
</style>
